'use strict';

import { isLoadedFromRefresh, appState, addDynEvents, HtmlFilter } from './appState.js';
import { ajaxWrapNew, ResponseDispatcher, CommandRegistry } from './ajaxWrapNew.js';
import { convert_empji_html, remove_emoji } from './Emojis.js';
import { optionsMenu } from './optionsMenu.js';
import { getUrlParam, setUrlParam, urlSafe } from './urlTools.js';
import { ActionSets } from './ActionSets.js';
import { mobileCheck } from './Screen.js';
import { ModalManager } from './ModalManager.js';
import { makePromise, nextFrame, sleep } from './asyncTools.js';
import { copyHtml } from './clipboardTools.js';
import { getUserTime } from './Times.js';
import { setScroll } from './Scrolls.js';
import { lmAppStorage } from './lmAppStorage.js';
import { ChatBoxEditable, createOutclickerOverlay, removeOutclickerOverlay, likechatEditModeOn, likechatEditModeOff } from './ChatBoxEditable.js';
import { miracleSync, resetChatItemExists, removeMiracleItemAnim } from './ChatSync.js';
import { VarMgr } from './VarMgr.js';
import { sorterCustom } from './Select2Tools.js';
import { initCrypter, canSecureCrypt, whenCrypter, whenCrypterReady, getCryptId, runAutoDecrypt, runAutoDecryptSmt, chatDecrypt, callDecrypt, chatEncrypt, processChatItemBeforeSend, processChatItemBeforeEdit } from './crypter.js';
//import { addDynEvents } from './DynEvents.js';
//import { HtmlFilter } from './HtmlFilter.js';

const CHAT_FORM_NAME_MAXLEN = 13;

const chatState = {
    instance: null,
    menuOpened: false,
    editModeOn: false,
    $box: null
};

const chatCommands = {
    closeChatMenu: () => {
        $(window).trigger('chtCloseMenu', { action: 'close' });
    },
    closeChatOptions: () => {
        $(window).trigger('jq-chat-option-menu', { action: 'close' });
    },

    newChat: (payload) => {
        $('.floatingChat').data('chat', payload.chat);
        if (payload.removeDefaultChanged) {
            if (VarMgr.get('isDefaultChanged')) {
                VarMgr.set('isDefaultChanged', false);
            }
            setUrlParam({
                'id': [true, payload.chat],
                'n': [false],
                'r': [false]
            });
        } else {
            setUrlParam('id', payload.chat);
        }
    },
    renameChat: (payload) => {
        if (!payload.newNameEncry) {
            $('.j-chatname').html(payload.newName);
            $('.chti-' + payload.chat).find('.ct').html(payload.newName);
        } else {
            callDecrypt(payload.newName, function (decrypted) {
                $('.j-chatname').html(decrypted);
                $('.chti-' + payload.chat).find('.ct').html(decrypted);
            });
        }
    },
    newChatItem: async (item) => {
        await chatState.instance.addNewChatItem(item.chatItemId, item.html, item.maxReached);
    },
    chatItemEdit: (payload) => {
        chatState.instance.startEditMode(payload);
    },
    chatItemEditClose: (payload) => {
        chatState.instance.stopEditModeHistory(false, true);
    },
    chatUpdate: (payload) => {
        likechatEditModeOff();
        chatState.instance.chatUpdate(payload);
    },
    chatLastEditedId: (id) => {
        chatState.$box.data('isedited', 0);
        chatState.$box.data('ctrlzId', id || 0);
    },

    chatItemRemove: (id) => {
        removeMiracleItemAnim(id, id, false);
        resetChatItemExists();
    },

    chatMaxReached: (payload) => {
        chatState.instance.maxReached(payload.html, payload.chatItemCreated);
    },

    removeDefaultChanged: () => {
        if (VarMgr.get('isDefaultChanged')) {
            VarMgr.set('isDefaultChanged', false);
            setUrlParam({
                'n': [false],
                'r': [false]
            });
        }
    },

    setNewChatFormName: async (form) => {
        if (typeof form.name != 'undefined') {
            let chat = $('.floatingChat').closest('[data-chat]').data('chat');

            let url = form.url;
            let formName = '';
            if (form.name) {
                formName = await chatDecrypt(form.name);
            }
            url = url.replace('{uuname}', encodeURIComponent(formName));
            url = url.replace('{chnr}', encodeURIComponent(form.nr || ''));
            if (chat) {
                urlSafe.assign(url);
            } else {
                urlSafe.assign(url); // Replace?
            }
        }
    },

    addChatNameFilter: () => {
        HtmlFilter.registerFilter('chatNameFilter', (html) => {
            if (html.indexOf('%chat-name%') > -1) {
                html = html.replace('%chat-name%', $('.pm-chat-name').first().text());
            }
            return html;
        });
    },
    addDynChatInfoViewFilter: (selector) => {
        addDynEvents((context, calledwhen) => {
            if (calledwhen == 'beforeShow') {
                if (!$(context).find(selector).length) {
                    return;
                }

                $(context).find('.to-aboutLink').each(function () {
                    $(this).attr('href', $('.aboutLink').first().attr('href'));
                });
                $(context).find('.chatTitle').each(function () {
                    $(this).text($('.cctarget-1').text());
                });
            }
        }, 'chatInfoViewFilter');
    },
    copyChatHTML: (html) => chatState.instance.copyChatHTML(html),

    chatSync: (payload) => {
        if (!payload) return;

        if (payload.items) {
            // te jāzin ir currentId - ar kuru ir interactions, lai zinātu ja sync ko pievieno, vai dzēš, lai skrolls iet uz augšu vai leju;'
            // un skipId - lai sync neapstrādā konkrētu id, piemēram, ja es tikko izveidoju un serveris atsūta atpakaļ manu pašu izveidoto ierakstu, tad es
            if (typeof miracleSync == 'function') {
                miracleSync(payload.items, payload.current, payload.except, false);
            }
        }
        if (payload.lastUpdated) {
            $('.chatParent').data('updated', payload.lastUpdated);
        }
    },

    newChatModal: (payload) => {
        newChatModalCreate(payload);
    },
};

const chatActions = {
    'cht-menu': () => {
        if (!chatState.menuOpened) {
            chatState.instance.menuOpen();
        } else {
            chatState.instance.menuClose();
        }
        return false;
    },
    'cht-back': () => {
        history.back();
        return false;
    },

    'cht-delete-this': (data) => {
        return data;
    },
    'cht-delete-this-confirm': (data) => {
        data.action = 'cht-delete-this';
        data.addData.deleteconfirm = 1;
        return data;
    },
    'cht-delete-confirm': (data) => {
        data.action = 'cht-delete';
        data.addData.deleteconfirm = 1;
        return data;
    },

    'cht-rename': (data) => {
        data.addData.encrypted = 1;
        return data;
    },
    'cht-rename-save': async (data) => {
        data.addData.encrypted = 1;
        if ($('.chatlist').length > 0) {
            data.addData.currentName = await chatEncrypt($('.chti-' + data.chat).find('.ct').text());
        } else {
            data.addData.currentName = await chatEncrypt($('.j-chatname').html());
        }
        var newName = getChatName($('.j-newname').val() || '');
        var canceled = false;
        var result = await processChatItemBeforeSend(newName, 'chatname').catch((err) => {
            canceled = true;
        });
        if (canceled) {
            return false;
        }
        if (!result || result.html == '') {
            data.addData.newName = newName;
        } else {
            data.addData.contains_emoji = result.contains_emoji;
            data.addData.newName = result.html;
        }
        return data;
    },

    'cht-submit': async (data) => {
        const el = data.el;

        data.addData.encrypted = 1;
        // data.addData.currentName = await chatEncrypt(jChatName());

        var canceled = false;
        var result = await processChatItemBeforeSend(chatState.$box.val(), 'chat').catch((err) => {
            canceled = true;
        });
        if (canceled || !result || result.html == '') {
            return false;
        }

        data.addData.contains_emoji = result.contains_emoji;
        data.addData.newChatItemHTML = result.html;
        data.addData.length = result.length;

        data.addData.cc = $(el).data('cc');
        const cctText = await remove_emoji($(el).text() || '');
        data.addData.cct = await chatEncrypt(cctText);

        if (data.iscustom) {
            if ($(el).data('default')) {
                if ($(el).data('default') != $(el).find('.pm-name').text()) {
                    const cctCustomText = await remove_emoji($(el).text());
                    data.addData.cctcustom = await chatEncrypt(cctCustomText);
                }
            }
        }

        if (chatState.instance.editModeOn) {
            data.action = 'cht-saveitem';
            data.addData.chtItemId = $('.floatingChat').closest('[data-chat]').data('editid');

            let original = chatState.$box.data('original');
            data.addData.textEdited = original.text != chatState.$box.val() ? 1 : '';
            data.addData.whoEdited = (original.who || 1) != data.addData.cc ? 1 : '';
        }

        if (data.addData.newChatItemHTML == '') {
            return false;
        }

        return data;
    },

    'cht-copy': (data) => {
        optionsMenu.copyAction(data.el, data.event);
        return false;
    },
    'cht-edititem': (data) => {
        data.addData.chtItemId = optionsMenu.currentBoxId() || 0;
        return data;
    },
    'cht-edititem-manual': (data) => {
        data.action = 'cht-edititem';
        data.addData = {
            ...(data.addData || {}),

            chtItemId: data.manualData?.chtItemId || 0,
            focusAfter: 1
        }
        return data;
    },
    'chtedit-discard-changes': (data) => {
        //ChatBoxEditable.clearChatBox();
        //ChatBoxEditable.stopEditMode();

        setTimeout(() => {
            chatState.instance.stopEditModeHistory(false, true);

            $(window).trigger('jq-chtedit-close', { confirm: true });
        }, 50);
        return false;
    },
    'chtedit-save-confirm': async (data) => {
        var canceled = false;
        var result = await processChatItemBeforeSend(chatState.$box.val(), 'chat').catch((err) => {
            canceled = true;
        });
        if (canceled || !result || result.html == '') {
            return false;
        }

        data.action = 'cht-saveitem';
        data.addData = {
            ...(data.addData || {}),

            encrypted: 1,
            confirm: 1,
            chtItemId: $('.floatingChat').closest('[data-chat]').data('editid'),

            contains_emoji: result.contains_emoji,
            newChatItemHTML: result.html,
            length: result.length
        };
        return data;
    },

    'cht-deleteitem': (data) => {
        data.addData.chtItemId = optionsMenu.currentBoxId() || 0;
        return data;
    },
    'cht-deleteitemconfirm': (data) => {
        data.action = 'cht-deleteitem';
        data.addData = {
            ...(data.addData || {}),

            chtItemId: $(data.el).data('id'),
            confirm: 1
        };
        return data;
    },

    'cht-copyfull': (data) => {
        return data;
    },

    // chat & chatlist
    /* 'cht-new': (data) => {
        alert('');
        return data;
    }, */
    'cht-new2': (data) => {
        return data;
    },
};

function filterChatFormName(name) {
    let tx = (name || '');//.split(' ')[0];
    tx = tx.replace(/\s+/g, ' ').trim();
    if (tx.length > CHAT_FORM_NAME_MAXLEN) {
        return tx.substring(0, CHAT_FORM_NAME_MAXLEN);
    }
    return tx;
}


var initChatPage = function (isLibrary) {

    const self = this;

    self.menuOpened = false;
    self.menuAnimating = false;
    self.currentPages = 0;
    self.isLibrary = isLibrary;

    self.libraryHistory = null;
    self.isRepost = false;

    const $chatbox = $('.chatinputbox');
    chatState.$box = $chatbox;

    CommandRegistry.registerCommands(chatCommands);
    ActionSets.registerSet('chatActions', chatActions);

    optionsMenu.addCopyHandler(function (text, box) {
        const $author = $(box).find('.author');
        if ($author.length) {
            $author.each(function () {
                text.push(optionsMenu.cleanText(this));
            });
            text.push(': ');
        }

        $(box).find('.text').each(function () {
            text.push(optionsMenu.cleanText(this));
        });
    });

    //this.scr = {};

    // chat
    self.menuOpen = function () {
        if (self.menuAnimating) {
            return;
        }

        self.menuAnimating = true;
        $('.mna')
            .css({
                opacity: '0',
                display: ''
            })
            .stop(true, false);

        if (!$('.mna').data('posleft')) {
            var pos = $('.mna').offset();
            $('.mna').data('posleft', pos.left);
            $('.mna').data('poswidth', $(window).width());

            $('.mna').css({
                position: 'fixed',
                top: pos.top - $(window).scrollTop(),
                left: (pos.left / $(window).width() * 100) + '%',
                zIndex: 990,
                width: $('.mna').outerWidth()
            }).appendTo('body');

        }

        $('.mna').before('<span class="overlayOutclicker chatmenu"></span>');
        $('.mna').animate({
            opacity: 1
        }, 200, 'swing', function () {
            $(this).css('opacity', '1');
            self.menuAnimating = false;
            self.menuOpened = true;
        });
    };
    self.menuClose = function () {
        if (self.menuAnimating) {
            return;
        }

        self.menuAnimating = true;
        $('.mna').stop(true, false).animate({
            opacity: 0
        }, 200, 'swing', function () {
            $(this).css('display', 'none').css('opacity', '0');
            $('.overlayOutclicker.chatmenu').remove();

            self.menuAnimating = false;
            self.menuOpened = false;
        });
    };

    self.addNewChatItem = async function (chatItemId, newChatHtml, maxReached) {
        $chatbox.val('');

        var resetAfter = true;
        const chatScroller = $chatbox.data('chatScroller');
        if (chatScroller) {
            chatScroller.stopFinal();
            resetAfter = false;
        }

        const $newelement = $(newChatHtml);
        const decryptPromise = runAutoDecrypt($newelement);
        await decryptPromise;
        $('.floatingTopff').before($newelement);

        resetChatItemExists();

        if (resetAfter) {
            // If the chat item is added to the top, scroll to the end
            if (!maxReached) {
                $chatbox.trigger('change', { $newelement: $newelement, forceupdate: true, scrolltoend: true });

                if (mobileCheck()) {
                    $chatbox.first().trigger("focus");
                }
            }
        }
        $(document).trigger('hideHovers');
    };

    self.maxReached = async function (lastChatHtml, chatItemCreated) {
        if (!chatItemCreated) {
            $chatbox.val('');
        }

        const $newelement = $(lastChatHtml);
        $('.floatingTopff').before($newelement);
        await runAutoDecrypt($newelement);

        resetChatItemExists();

        $('body').addClass('chatMaxReached');
        $chatbox.trigger('change', { $newelement: $newelement, forceupdate: true, scrolltoend: true });
    };

    // vairs neizmanto jo izmanto redirektu;
    /* self.setPmName = function (name) {
        $('.pm-name').html(name);
        $('.chat-h > .md').toggleClass('useSmall', name.length > 6);
    }; */

    self.editModeOn = false;
    self.startEditMode = async function (chatEdit) {
        await appState.globalCrypter.testTimeout();
        if (!appState.globalCrypter.ready) {
            await initCrypter({ from: 'crypt', skippable: false });
        }

        $('.outclicker-target').addClass('outclicker-chat');
        const $overlay = createOutclickerOverlay();
        if ($overlay) {
            $overlay.on('click', function () {
                if (self.editModeOn) {
                    if (self.canStopEditMode()) {
                        self.stopEditModeHistory();
                    }
                }
            });
            appState.historyInstance.push('cht1');
        }

        $('.floatingChat').each(function () {
            $(this).closest('[data-chat]')
                .data('iseditmode', 1)
                .data('editid', chatEdit.id);

            if (chatEdit.who == 1 && $(this).data('iscustom') && chatEdit.whoText) {
                $(this).find('.cctarget-1').each(function () {
                    $(this).clone().addClass('isClone').insertAfter(this);
                    $(this).css({
                        display: 'none'
                    });
                });
            } else if (chatEdit.iscustomchanged) {
                $(this).find('.cctarget-1').each(function () {
                    $(this).clone().addClass('isClone').insertAfter(this);
                    $(this).css({
                        display: 'none'
                    });
                });
            }

            $(this).find('.md')
                .addClass('useEdit')
                .append($('<span class="title-edit"></span>').html(chatEdit.title));
        });

        chatEdit.text = await chatDecrypt(chatEdit.text);
        if (chatEdit.who) {
            chatEdit.who = await chatDecrypt(chatEdit.who);
        }
        var cleanEditText = await processChatItemBeforeEdit(chatEdit.text, 'chat');

        ChatBoxEditable.startEditMode(() => {
            /* if (self.canStopEditMode()) {
                self.stopEditMode();
            } */
            // caur tejieni neizslēdzam edit mode;
            return false;
        });
        $chatbox.data('original', {
            text: cleanEditText,
            who: chatEdit.who
        });
        $chatbox.val(cleanEditText);
        $chatbox.trigger('change', { forceupdate: true, lockScroll: true });

        //likechatEditModeOn();
        /* setTimeout(function () {
            $chatbox.trigger('focus');
        }, 200); */
        self.editModeOn = true;
    };

    self.markForced = false;
    self.stopEditModeHistory = function (nohistory, force) {
        if (!nohistory) {
            if (force) {
                self.markForced = true;
            }
            if (!force && self.editModeOn) {
                if (!self.canStopEditMode()) {

                    return;
                }
            }
            appState.historyInstance.go(-1);
            return;
        }

        if (self.markForced) {
            force = true;
            self.markForced = false;
        }
        if (!force && self.editModeOn) {
            if (!self.canStopEditMode()) {
                setTimeout(() => {
                    appState.historyInstance.push('cht1');
                }, 0);
                return;
            }
        }

        self.stopEditMode();
    };
    self.stopEditMode = function () {
        $('.floatingChat').each(function () {
            $(this).closest('[data-chat]')
                .data('iseditmode', 0)
                .data('editid', '');

            $(this).find('.cctarget-1').each(function () {
                if ($(this).hasClass('isClone')) {
                    $(this).remove();
                } else {
                    $(this).css({
                        display: ''
                    });
                }
            });

            $(this).find('.md').removeClass('useEdit');
            $(this).find('.title-edit').remove();
        });

        //likechatEditModeOff();
        // pārvietojam pirms tiek updeitots čats lai jau noņem lock, lai var skroll sabīdīt kur vajag;

        ChatBoxEditable.clearChatBox();
        ChatBoxEditable.stopEditMode();

        $('.outclicker-target').removeClass('outclicker-chat');
        removeOutclickerOverlay();

        self.editModeOn = false;
    };

    self.canStopEditMode = function () {
        const orig = $chatbox.data('original');
        const newVal = $chatbox.val();
        var changed = false;
        if (orig) {
            if (orig.text != newVal && newVal != '') {
                changed = true;
            }
        }

        if (changed) {
            var sid = 0, id = 0, chat = 0, chtItemId = 0;
            $('.floatingChat').each(function () {
                sid = $(this).closest('[data-sid]').data('sid');
                id = $(this).closest('[data-id]').data('id');
                chat = $(this).closest('[data-chat]').data('chat');
                chtItemId = $(this).closest('[data-chat]').data('editid');
            });

            setTimeout(async function () {
                let pendingModalToken = null;
                let pendingModalReleased = false;
                let pendingModalTimeout = null;
                const releasePendingModalLock = function () {
                    if (pendingModalReleased) {
                        return;
                    }
                    pendingModalReleased = true;

                    if (pendingModalTimeout) {
                        clearTimeout(pendingModalTimeout);
                        pendingModalTimeout = null;
                    }

                    if (pendingModalToken && ModalManager) {
                        ModalManager.close(pendingModalToken);
                        pendingModalToken = null;
                    }
                };

                likechatEditModeOff();

                if (ModalManager) {
                    pendingModalToken = ModalManager.open({
                        name: 'chatEditCloseConfirmPending',
                        locksScroll: false
                    });
                    pendingModalTimeout = setTimeout(function () {
                        releasePendingModalLock();
                    }, 8000);
                }

                var newChatItemHTML = '';
                var newChatItemLength = 0;
                var contains_emoji = 0;

                var canceled = false;
                var result = await processChatItemBeforeSend($chatbox.val(), 'chat').catch((err) => {
                    canceled = true;
                });
                if (canceled) {
                    return false;
                }
                if (result && result.html != '') {
                    newChatItemHTML = result.html;
                    newChatItemLength = result.length;
                    contains_emoji = result.contains_emoji;
                }

                ajaxWrapNew({
                    method: 'POST',
                    data: {
                        ajax: 1,
                        action: 'cht-edit-closeConfirm',
                        sid: sid,
                        id: id,
                        chat: chat,
                        chtItemId: chtItemId,
                        newChatItemHTML: newChatItemHTML,
                        length: newChatItemLength,
                        contains_emoji: contains_emoji,

                        syCurrent: chtItemId,
                        updated: $('.chatParent').data('updated') || 0
                    },
                    success: async function (data) {
                        try {
                            await ResponseDispatcher.handle(data, 'cht-edit-closeConfirm');
                        } finally {
                            releasePendingModalLock();
                        }
                    },
                    complete: function () {
                        releasePendingModalLock();
                    },
                    dataType: 'json'
                });
            }, 0);

            return false;
        }

        return true;
    };

    self.chatUpdate = async function (chatUpdate) {
        if (chatUpdate.cct) {
            chatUpdate.cct = await chatDecrypt(chatUpdate.cct);
        }
        chatUpdate.text = await chatDecrypt(chatUpdate.text);

        const prevHeight = $('.chatItem[data-id="' + chatUpdate.id + '"]').outerHeight();
        $('.chatItem[data-id="' + chatUpdate.id + '"]').each(function () {
            $(this).removeClass('cc' + (chatUpdate.who == 2 ? 1 : 2)).addClass('cc' + chatUpdate.who);

            $(this).find('.text').each(function () {
                if ($(this).find('.chatEd').length) {
                    $(this).find('.chatEd').html(chatUpdate.text);
                } else {
                    $(this).html(chatUpdate.text);
                }
            });
            if (chatUpdate.cct) {
                $(this).find('.author').each(function () {
                    if ($(this).find('.chatEd').length) {
                        $(this).find('.chatEd').html(chatUpdate.cct).attr('title', chatUpdate.title || '');
                    } else {
                        $(this).html(chatUpdate.cct).attr('title', chatUpdate.title || '');
                    }
                });
            }
        });
        await nextFrame();
        const newHeight = $('.chatItem[data-id="' + chatUpdate.id + '"]').outerHeight();
        $chatbox.trigger('change', { heightDiff: newHeight - prevHeight, forceupdate: true });
    };

    self.copyChatHTML = async function (html) {
        var $tmp = $('<div class="clipboardHtml2"></div>').css({
            top: 5,
            left: 5
        }).html(html);

        var chatName = jChatName();
        if (chatName) {
            $tmp.find('.jq-chat-title').html(chatName);
        } else {
            $tmp.find('.jq-chat-title').closest('.if-exists').remove();
        }

        if ($tmp.find('[data-secure="1"]').length) {
            await runAutoDecrypt($tmp);
        }

        var list = [];

        $('.chatParent').find('.chatItem').not('.chatItemIsMax').each(function () {
            if ($(this).hasClass('removing')) {
                return;
            }
            let title = $(this).find('.author').find('.chatEd').length ? $(this).find('.author').find('.chatEd').html() : $(this).find('.author').html();
            let text = $(this).find('.text').html();
            list.push('<strong><i>' + title + ':</i></strong> <cite>' + text + '</cite><br />');
        });

        $tmp.find('.jq-chat-html').html(list.join(''));

        await convert_empji_html($tmp);
        $('body').append($tmp);

        copyHtml($tmp.get(0), function (element, result) {
            setTimeout(function () {
                $tmp.remove();
            }, 1000);
        });
    };

    self.chtAction = async function (act) {
        if (!act) {
            return;
        }
        //action, sid, id, chat, iscustom, el, event, manualData = {}
        const origArguments = arguments;

        var addData = {};

        if ($(act.el).data('addtag')) {
            let addTag = $(act.el).data('addtag');
            addData[addTag] = 1;
        }
        var after = null;
        try {
            const actionData = {
                action: act.action,
                sid: act.sid,
                id: act.id,
                chat: act.chat,
                iscustom: act.iscustom,
                el: act.element,
                event: act.event,
                manualData: act.manualData || {},
                addData: addData
            };
            const result = await ActionSets.handleAction(act.action, actionData);
            if (result === false) {
                return;
            }
            if (result && typeof result === 'object') {
                if (result.action) {
                    act.action = result.action;
                }
                if (result.addData) {
                    Object.assign(addData, result.addData);
                }
            }
        } catch (e) {
            console.log('Error occurred while processing chat action:', e.message);
            console.warn(e);
            return;
        }

        if (self.isLibrary) {
            addData.libraryId = $('.chatlist').data('id');
        }
        // @ts-ignore
        if (VarMgr.get('isDefaultChanged') /* && act.action != 'chat-form-rename-save' */) {
            addData.defaultChanged = 1;
            addData.newChatFormName = await chatEncrypt($('.pm-name').first().text());
            addData.newChatFormNr = $('.pm-name').data('nr') || 0;
        }

        if (addData?.encrypted) {
            addData.cryptId = getCryptId();
        }

        const ajaxData = $.extend({
            ajax: 1,
            action: act.action,
            sid: act.sid,
            id: act.id,
            chat: act.chat,
            time: getUserTime(),

            syCurrent: addData.chtItemId || 0,
            updated: $('.chatParent').data('updated') || 0
        }, addData);

        if (typeof window['chtActionAjaxPosting'] != 'undefined') {
            if (window['chtActionAjaxPosting']) {
                return false;
            }
        }
        window['chtActionAjaxPosting'] = true;
        ajaxWrapNew({
            method: 'POST',
            data: ajaxData,
            success: async function (data) {
                try {
                    if (data.repost) {
                        if (self.isRepost) {
                            throw new Error('Repost failed');
                        }
                        await ResponseDispatcher.handle(data, act.action + '-repost');

                        self.isRepost = true;
                        self.chtAction(...origArguments);
                        return false; // apturam pārējās darbības;
                    }

                    self.isRepost = false;
                    await ResponseDispatcher.handle(data, act.action);

                    if (data.ok) {
                        after && after(data);
                    }
                } catch (e2) {
                    console.log(e2);
                }
            },
            complete: function () {
                window['chtActionAjaxPosting'] = false;
            },
            dataType: 'json'
        });
    };


    appState.historyInstance.add('cht1', {
        value: null,
        backCallback: function (change) {
            self.stopEditModeHistory(true);
        },
        checkCallback: function (value) {
            return self.editModeOn ? true : null;
        },
        goBackOnRefresh: true
    });

    // tikai čatam;
    if ($chatbox.length) {
        $('body').on('keydown', function (event) {
            if (event.ctrlKey || event.metaKey) {
                if (event.key === 'z' || event.key === 'Z') {
                    if (!$chatbox.length) { return; }
                    if ($chatbox.data('isedited')) { return; }
                    const ctrlzId = $chatbox.data('ctrlzId');
                    if (ctrlzId) {
                        event.preventDefault();

                        var sid = 0, id = 0, chat = 0, iscustom = '';
                        $('.floatingChat').each(function () {
                            sid = $(this).closest('[data-sid]').data('sid');
                            id = $(this).closest('[data-id]').data('id');
                            chat = $(this).closest('[data-chat]').data('chat');
                            iscustom = $(this).data('iscustom');
                        });
                        self.chtAction({
                            action: 'cht-edititem-manual',
                            sid: sid,
                            id: id,
                            chat: chat,
                            iscustom: iscustom,
                            element: null,
                            event: event,
                            manualData: {
                                chtItemId: ctrlzId
                            }
                        });
                    } else {
                        console.log('no ctrlzId'); return;
                    }
                }
            }
        });
    }

    $('body').on('click.cht', '.chatEd', function (event) {
        event.stopPropagation();
        $(window).trigger('jq-chat-option-menu', { action: 'open', el: this, event: event });
    });

    $('body').on('click.cht', '.outclicker-chat', function (event) {
        if (self.editModeOn) {
            if (self.canStopEditMode()) {
                self.stopEditModeHistory();
            }
        }
    });

    $('body').on('click.cht', '.cht', function (event) {
        if ($(this).is('a')) {
            event.preventDefault();
        }

        event.stopPropagation();

        if ($(this).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }

        var sid = 0, id = 0, chat = 0, iscustom = '';
        if ($('.chatlist').length > 0) {
            sid = $(this).closest('[data-sid]').data('sid') || 0;
            id = $(this).closest('[data-id]').data('id') || 0;
            chat = $(this).closest('[data-chat]').data('chat') || 0;
        } else {
            $('.floatingChat').each(function () {
                sid = $(this).closest('[data-sid]').data('sid');
                id = $(this).closest('[data-id]').data('id');
                chat = $(this).closest('[data-chat]').data('chat');
                iscustom = $(this).data('iscustom');
            });
        }

        self.chtAction({
            action: $(this).data('action'),
            sid: sid,
            id: id,
            chat: chat,
            iscustom: iscustom,
            element: this,
            event: event
        });
    });

    $('body').on('click.cht', '.mna', function (event) {
        event.stopPropagation();
    });

    /* $('.floatingChat .title-custom .pm-chat-name, .floatingChat .title-custom-small .pm-chat-name').on('click.cht', function (event) {
        event.stopPropagation();

        if ($(this).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }

        var sid = 0, id = 0, chat = 0, iscustom = '';
        $('.floatingChat').each(function () {
            sid = $(this).data('sid');
            id = $(this).data('id');
            chat = $(this).data('chat');
            iscustom = $(this).data('iscustom');
        });

        self.chtAction({
            action: 'chat-form-rename',
            sid: sid,
            id: id,
            chat: chat,
            iscustom: iscustom,
            element: this,
            event: event
        });
    }); */


    // čata input containera klikšķis
    $('body').on('click.cht', '.chat-i', function (event) {
        event.stopPropagation();

        if (document.activeElement != $chatbox.get(0)) {
            $chatbox.trigger('focus');
            return;
        }
    });


    $(window).on('jq-chtedit-close', function (event) {
        if (self.menuOpened) {
            self.menuClose();
        }
    });

    $(window).on('chtCloseMenu', function (event) {
        if (self.editModeOn) {
            if (self.canStopEditMode()) {
                self.stopEditModeHistory();
            }
        }
        if (self.menuOpened) {
            self.menuClose();
        }
    });

    $(window).on('jq-outclick.cht', function (event) {
        if (self.menuOpened) {
            self.menuClose();
        }
    });

    $(window).on('jq-resize-end', function (event, w) {
        if ($('.mna').data('posleft')) {
            let diff = $(window).width() - $('.mna').data('poswidth');

            $('.mna').css({
                left: (($('.mna').data('posleft') + diff) / $(window).width() * 100) + '%',
            });
        }
    });

};


var initChatOptions = function () {
    $(window).on('jq-chat-option-menu', function (event, param) {
        if (param.action == 'open') {
            optionsMenu.open(param);
        }
        if (param.action == 'close') {
            optionsMenu.close(param);
        }
    });
};

function startChatScroll(speeds) {
    const self = this;

    $('body').addClass('chat-input-lock-paused');
    likechatEditModeOff();

    const getValue = function (name, def, sToMs) {
        if (speeds) {
            if (typeof speeds[name] === 'undefined') {
                return def;
            }

            return Math.round(parseFloat(speeds[name]) * (sToMs ? 1000 : 1));
        }

        if ($('.jsim2-taba.active').length) {
            var $activeParent = $($('.jsim2-taba.active').data('key'));
            const $input = $activeParent.find('.jsim2input[data-id="' + name + '"]');
            if ($input.length) {
                const value = $input.val();
                if (value) {
                    // @ts-ignore
                    return Math.round(parseFloat(value) * (sToMs ? 1000 : 1));
                }
            }
        }

        return def;
    };

    const firstScrollSpeed = getValue('firstScrollSpeed', 200, true);
    const startDelay = getValue('startDelay', 1000, true);
    const pxPerSecond = getValue('pxPerSecond', 100, false);
    const endDelay = getValue('endDelay', 2000, true);
    const endOpacitySpeed = getValue('endOpacitySpeed', 2000, true);
    const stopOpacitySpeed = getValue('stopOpacitySpeed', 1000, true);


    const easing = 'linear';
    const stopSpeed = 200;

    self.$fakeItem = $();
    self.$scrollAnimObj = $({
        animValue: 0
    });
    self.isAnimating = false;
    self.isPaused = false;

    self.isFinalStop = false;
    self.isForceFast = false;

    self.stopCounter = 0;
    self.stopNow = 0;

    self.pauseStart = false;
    self.pauseStartAt = null;
    self.pauseEndAt = null;
    self.pauseDiff = null;
    self.prevNow = null;
    self.diffTotal = 0;

    self.pause = function () {
        if (self.isAnimating) {
            //self.pauseStart = true;
            //self.stopCounter = stopSpeed;
            self.stop();
        }
    };

    self.stop = function () {
        if (self.isAnimating) {
            self.isPaused = true;
            self.$scrollAnimObj.clearQueue();
            self.$scrollAnimObj.stop();
        }
    };

    self.restart = function () {
        if (self.isFinalStop) {
            return;
        }
        if (self.isAnimating) {
            self.isPaused = false;
            self.$scrollAnimObj.clearQueue();
            self.$scrollAnimObj.stop();
            self.start(2);
        }
    };

    self.isMouseDown = false;
    self.isMouseDownDelayed = false;
    self.mouseDownDelay = 300;

    var downHandler = function (event) {
        self.isMouseDown = true;
        if (self.isFinalStop) {
            return;
        }

        setTimeout(function () {
            if (self.isMouseDown) {
                self.isMouseDownDelayed = true;
                self.pause();
            }
        }, self.mouseDownDelay);
    };
    var upHandler = function (event) {
        self.isMouseDown = false;
        if (self.isFinalStop) {
            return;
        }
        if (!self.isMouseDownDelayed) {
            return;
        }
        self.isMouseDownDelayed = false;
        self.restart();
    };
    var clickHandler = function (event) {
        /* if (self.isFinalStop) {
            return;
        }
        if (self.isPaused) {
            self.restart();
        } else {
            self.pause();
        } */
    };

    self.beforeOverflow = null;
    self.disableScrollBar = function () {
        self.beforeOverflow = $('body').css('overflow');
        $('body').css('overflow', 'hidden');
    };

    self.restoreScrollBar = function () {
        $('body').css('overflow', self.beforeOverflow || '');
    };

    self.start = function (level) {
        if (self.isFinalStop) {
            return;
        }

        // @ts-ignore
        chatState.$box.data('chatScroller', this);
        $('body').addClass('chat-scroll-animating');

        let currentScroll = $(window).scrollTop();
        const $scrollSetEl = $('html, body');

        // tad izveidotais čats aiziet uz pašu sākumu
        if (level == 0) {
            if (currentScroll > 0) {// firstScrollSpeed
                //$('html, body').scrollTop(0);
                /* scrollUpdateAnim(0 - currentScroll, 0, function () {
                    self.start(1);
                }); */
                setScroll(0);
                setTimeout(function () {
                    setScroll(0);
                    $('.chatMargin').css({
                        opacity: 1
                    });
                    self.start(1);
                }, 200);
                return;
            } else {
                setTimeout(function () {
                    setScroll(0);
                    $('.chatMargin').css({
                        opacity: 1
                    });
                    self.start(1);
                }, 200);
                return;
            }
            //level = 1;
        }

        // un pēc 1 sekundes stāvēšanas šajā pozīcijā
        if (level == 1) {
            self.disableScrollBar();
            setTimeout(function () {
                self.start(2);
            }, Math.max(0, startDelay - 200));
            return;
        }

        // čats sāk lēni scrollēties uz augšu - tā it kā čats tiktu rādīts kā filmas titri - no sākuma līdz beigām
        // Beigas būtu tādas ka viss teksts aizscrollējas līdz tas ir pavisam neredzams.
        if (level == 2) {
            $('body')
                .off('mousedown.scrsim touchstart.scrsim', downHandler)
                .on('mousedown.scrsim touchstart.scrsim', downHandler);
            $('body')
                .off('mouseup.scrsim touchend.scrsim', upHandler)
                .on('mouseup.scrsim touchend.scrsim', upHandler);
            $('body')
                .off('click.scrsim', clickHandler)
                .on('click.scrsim', clickHandler);

            const maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
            const scrollDuration = Math.abs(maxScroll - currentScroll) / pxPerSecond * 1000;
            self.$scrollAnimObj[0].animValue = currentScroll;

            // @ts-ignore
            var diff = 0;
            self.$scrollAnimObj.animate({
                animValue: maxScroll
            }, {
                duration: scrollDuration,
                easing: easing,
                // @ts-ignore
                // @ts-ignore
                step: function (now, tween) {
                    $scrollSetEl.scrollTop(now);
                },
                complete: function () {
                    self.start(3);
                }
            });
            self.isAnimating = true;
            return;
        }
        self.isAnimating = false;

        // Vēl pāris sekundes
        if (level == 3) {
            setTimeout(function () {
                self.start(4);
            }, endDelay);
            return;
        }


        // un čats parādās (uzdziest) tur kur ir pēdējais ieraksts no apakšas.
        if (level == 4) {
            chatState.$box.data('chatScroller', null);
            $('.chatMargin').css({
                paddingTop: ''
            });
            const $parent = $('.chatParent').closest('.chatHeight');
            const fakeHeight = self.$fakeItem.height();

            $parent.css({
                opacity: 0
            });
            $scrollSetEl.scrollTop(currentScroll - fakeHeight);
            self.$fakeItem.remove();

            $parent.animate({
                opacity: 1
            }, endOpacitySpeed, 'swing', function () {
                self.start(5);
            });
            return;
        }

        // DONE ??
        self.isFinalStop = true;
        $('body').removeClass('chat-input-lock-paused');
        $('body').removeClass('chat-scroll-animating');
        $('.if-notscroll').show();
        $('.if-scroll').hide();
        $('.chatMargin').css({
            paddingTop: ''
        });
        chatState.$box.trigger('change', { forceupdate: true });
        chatState.$box.data('chatScroller', null);
        self.restoreScrollBar();
    };

    self.stopFinal = function (forceFast) {
        var stopPromise = makePromise();
        if (self.isFinalStop) {
            stopPromise.resolve();
            return stopPromise;
        }
        self.isFinalStop = true;
        self.isForceFast = forceFast || false;
        $('body').removeClass('chat-input-lock-paused');

        chatState.$box.val('');
        chatState.$box.trigger('change', { forceupdate: true });
        $(window).trigger('jq-chtedit-close', { confirm: true });

        const $parent = $('.chatParent').closest('.chatHeight');

        if (self.isForceFast) {
            self.stop();
            self.$fakeItem.remove();

            $parent.stop(true, true).animate({
                opacity: 1
            }, 10, 'swing', function () {

            });

            self.restoreScrollBar();
            stopPromise.resolve();

            return stopPromise;
        }
        $parent.data('isStoppingFinal', 1);
        $parent.data('isStoppingFinalPromise', stopPromise.promise);
        $parent.animate({
            opacity: 0
        }, stopOpacitySpeed, 'swing', function () {
            self.stop();
            self.$fakeItem.remove();

            setTimeout(function () {
                const maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
                $('html, body').scrollTop(maxScroll);

                setTimeout(function () {
                    $parent.animate({
                        opacity: 1
                    }, endOpacitySpeed, 'swing', function () {
                        $('body').removeClass('chat-scroll-animating');
                        $('.if-notscroll').show();
                        $('.if-scroll').hide();
                        $('.chatMargin').css({
                            paddingTop: ''
                        });
                        self.restoreScrollBar();
                        $parent.data('isStoppingFinal', 0);

                        chatState.$box.data('chatScroller', null);

                        stopPromise.resolve();
                    });
                }, endDelay);
            }, 0);
        });

        return stopPromise;
    };

    /* $( window ).on('scroll', function() {
        console.log('$( window ).scrollTop()', $( window ).scrollTop());
    }); */

    var startInit = function () {
        chatState.$box.val('');
        chatState.$box.trigger('change', { forceupdate: true });
        $(window).trigger('jq-chtedit-close', { confirm: true });

        const currentMarginBottom = parseInt($('.chatMargin').css('paddingBottom')) || 0;
        $('.chatItemLastFake').remove();
        $('.chatItem').last().after(
            $('<div class="chatItemLastFake"></div>').css({
                height: 'calc(var(--lm-lock-vh, 100dvh) - ' + currentMarginBottom + 'px)'
            }).each(function () {
                self.$fakeItem = $(this);
            })
        );

        $('.chatMargin').css({
            paddingTop: 'calc(var(--lm-lock-vh, 100dvh) - 200px)',
            opacity: 0
        });

        self.start(0);

        $('.if-notscroll').hide();
        $('.if-scroll').show();
    };

    const chatScrollerBefore = chatState.$box.data('chatScroller');
    if (chatScrollerBefore) {
        $(window).trigger('jq-chtedit-close', { confirm: true });

        const $parent = $('.chatParent').closest('.chatHeight');
        if ($parent.data('isStoppingFinal')) {
            $parent.data('isStoppingFinalPromise').then(() => {
                chatScrollerBefore.stopFinal(true).promise.then(() => {
                    startInit();
                });
            });
            return;
        }
        chatScrollerBefore.stopFinal(true).promise.then(() => {
            startInit();
        });
        return;
    }

    startInit();
}


var jChatName = function () {
    const currentName = $('.j-chatname').html();
    const defaultName = $('.j-chatname').data('default') || '';
    if (currentName != defaultName) {
        return currentName;
    }

    return '';
};



const CHAT_NAME_MAXLEN = 100;
var getChatName = function (t) {
    let tx = (t || '');
    if (tx.length > CHAT_NAME_MAXLEN) {
        return tx.substring(0, CHAT_NAME_MAXLEN);
    }
    return tx;
};

var loadChatPageScroll = function (urlReplace, smart) {
    if (smart) {
        if (isLoadedFromRefresh()) {
            // izlaižam scroll ja lietotājs ir atjaunojis lapu;
            return false;
        }
    }

    setScroll($('html, body').prop('scrollHeight') - $(window).height());

    if (urlReplace) {
        const currentState = history.state || {};
        appState.historyInstance.replaceState(currentState, null, urlReplace);
    }
};

async function initChatHome(conf = {}) {
    const context = conf.context || document;
    const dropdownParent = conf.dropdownParent || document.body;

    let $selectSuggested = $('.select2chattype[name="suggested"]', context);
    let $selectMy = $('.select2chattype[name="my"]', context);
    //let $selectLibrary = $('.select2chattype[name="library"]', context);
    let dontHideAfterHistory = false;

    const $newConversationContent = $('.newconversation-content', context);
    const $myConversations = $('.myconversations', context);
    const useListTemplate = $myConversations.hasClass('use-template');

    const templateResultCounter = function( state ) {
        if (!state.id) {
            return state.text;
        }
        const counter = $( state.element ).data('counter');
        return $(
            '<span> ' + state.text + (counter ? ' (' + counter + ')' : '') + '</span>'
        );
    };

    const templateSelectionCounter = function( state ) {
        const counter = state.element ? $( state.element ).data('counter') : 0;
        return $(
            '<span style="display: inline-block; text-indent: 0;"> ' + state.text + (counter ? ' (' + counter + ')' : '') + '</span>'
        );
    };

    const createMyFromTemplate = async () => {
        if ($myConversations.data('initdone')) {
            return;
        }
        // Uzliekam uzreiz initdone lai izvairītos no dubultas inicializācijas;
        $myConversations.data('initdone', true);

        const tpl = /** @type {HTMLTemplateElement} */ (document.getElementById('myConversationListContent'));
        const clone = /** @type {DocumentFragment} */ (tpl.content.cloneNode(true));
        $myConversations.find('.list').empty().append(clone);
        await runAutoDecryptSmt($myConversations.find('.list')).then(() => {

        }).catch(() => {
            $myConversations.data('initdone', false);
            throw new Error('Auto decrypt canceled');
        });
    };
    const createNewFromTemplate = async () => {
        if ($newConversationContent.data('initdone')) {
            return;
        }
        // Uzliekam uzreiz initdone lai izvairītos no dubultas inicializācijas;
        $newConversationContent.data('initdone', true);

        const tpl = /** @type {HTMLTemplateElement} */ (document.getElementById('newConversationContent'));
        const clone = /** @type {DocumentFragment} */ (tpl.content.cloneNode(true));
        $newConversationContent.empty().append(clone);
        await runAutoDecryptSmt($newConversationContent).then(() => {
            $selectSuggested = $('.select2chattype[name="suggested"]', context);
            $selectMy = $('.select2chattype[name="my"]', context);
        }).catch(() => {
            $newConversationContent.data('initdone', false);
            throw new Error('Auto decrypt canceled');
        });

        $('.select2chattype').select2({
            dropdownAutoWidth: true,
            dropdownParent: dropdownParent,
            width: '100%',
            sorter: sorterCustom,
            templateResult: templateResultCounter,
            templateSelection: templateSelectionCounter
        });
    };

    const init = async () => {
        if ($newConversationContent.data('initdone')) {
            return;
        }
        if (!$newConversationContent.hasClass('use-template')) {
            $newConversationContent.data('initdone', true);
            return;
        }

        await createNewFromTemplate().then(() => {

        }).catch((e) => {
            throw e;
        });
    };
    const open = async (nohistory, chattype) => {
        var canceled = false;
        if (!$newConversationContent.data('initdone')) {
            await init().catch(() => {
                canceled = true;
            });
            if (canceled) {
                $('.chat2add').animate({ opacity: 1 }, 300);
                return;
            }
        }

        $('.default-content', context).hide();
        $newConversationContent.show();

        if (chattype) {
            $('.chattype[value="' + chattype + '"]', context)
                .prop('checked', true)
                .trigger('click');
        }
        else if (conf.openTab) {
            $('.chattype[value="' + conf.openTab + '"]', context)
                .prop('checked', true)
                .trigger('click');
            if (conf.selectOption) {
                $selectSuggested.val(conf.selectOption).trigger('change');
            }
            if (conf.fillName) {
                const decryptedFillName = await chatDecrypt(conf.fillName);
                $('.inputchattype[name="customname"]', context).val(decryptedFillName);
            }
        }

        if (!nohistory) {
            appState.historyInstance.push('newconversation');
        }

        if (conf.onOpen) {
            conf.onOpen();
        }
    };

    const close = (nohistory, dontHide) => {
        if (!nohistory) {
            dontHideAfterHistory = dontHide || false;
            appState.historyInstance.go(-1);
            return;
        }

        if (!dontHide && !dontHideAfterHistory) {
            $newConversationContent.hide();
            $('.default-content', context).show();
        }

        $('.chat2add').animate({ opacity: 1 }, 300);

        if (conf.onClose) {
            conf.onClose();
        }
    };

    const createSuggested = (val) => {
        const $opt = $selectSuggested.find('option[value="' + val + '"]');
        if (!$opt.length) {
            return false;
        }

        const url = $opt.data('url');
        appState.historyInstance.afterPopstate = function () {
            setTimeout(function () {
                window.location.assign(url);
            }, 20);
            return false;
        };
        close(false, true);
    };

    const createMy = (val, item) => {
        const $opt = $selectMy.find('option[value="' + val + '"]');
        let url;
        if (!$opt.length) {
            url = item ? item.url : '';
        } else {
            url = $opt.data('url');
        }
        if (!url) {
            return false;
        }

        appState.historyInstance.afterPopstate = function () {
            setTimeout(function () {
                window.location.assign(url);
            }, 20);
            return false;
        };
        close(false, true);
    };

    const try2FindCustom = async (val) => {
        let foundItem = null;
        const data = await ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'cht-get-customlist',
            },
            dataType: 'json'
        });

        let decryptionPromises = [];
        try {
            await ResponseDispatcher.handle(data, 'cht-get-customlist');
            if (data.ok && data.customList) {
                $.each(data.customList, function(key, dat) {
                    decryptionPromises.push(
                        chatDecrypt(dat.chatname).then(decryptedValue => {
                            if (decryptedValue === val) {
                                foundItem = dat;
                                return false;
                            }
                        })
                    );
                });
                await Promise.all(decryptionPromises);
            }
        } catch (e) {
            console.error('Error handling custom list:', e);
        }

        return foundItem;
    };

    const createNewCustom = async (val) => {
        const encryptedVal = await chatEncrypt(val);
        const data = await ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'cht-new-custom',
                chatname: encryptedVal
            },
            dataType: 'json'
        });

        try {
            await ResponseDispatcher.handle(data, 'cht-new-custom');
            if (data.ok && data.newItem) {
                createMy(data.newItem.custom_id, data.newItem);
            }
        } catch (e) {
            console.error('Error handling custom list:', e);
        }

        return data.newItem;
    };

    const newcreate = () => {
        const chattype = $('.chattype:checked', context).val();
        if (chattype == 'suggested') {
            const val = $selectSuggested.val();
            if (!val) {
                return false;
            }
            createSuggested(val);
        } else if (chattype == 'custom') {
            const $input = $('.inputchattype[name="customname"]', context);
            const val = $input.val().toString().trim();
            if (!val) {
                $input.addClass('empty-blink');
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        $input.addClass('empty-blink-fade').removeClass('empty-blink');
                        setTimeout(() => {
                            $input.removeClass('empty-blink-fade');
                        }, 200);
                    }, 200);
                });
                return false;
            }

            //  te vēl jāsaprot vai tā nesakrīt ar kādu no suggested čatiem, vai jau eksistē kāds custom čats ar šo nosaukumu.
            let foundSuggested = false;
            $selectSuggested.find('option').each(function() {
                const suggestedVal = $(this).text();
                if (suggestedVal === val) {
                    foundSuggested = true;
                    createSuggested($(this).val());
                    return false;
                }
            });
            if (foundSuggested) {
                return false;
            }

            let foundMy = false;
            $selectMy.find('option').each(function() {
                const myVal = $(this).text();
                if (myVal === val) {
                    foundMy = true;
                    createMy($(this).val());
                    return false;
                }
            });
            if (foundMy) {
                return false;
            }

            try2FindCustom(val).then(foundItem => {
                if (foundItem) {
                    createMy(foundItem.custom_id, foundItem);
                } else {
                    createNewCustom(val);
                }
            });
        } else if (chattype == 'my') {
            const val = $selectMy.val();
            if (!val) {
                return false;
            }
            createMy(val);
        }
        return false;
    };

    const filterDuplicateCustom = async () => {
        const convertList = {
            toSuggested: {},
            toMy: {}
        };
        var counter = 0;

        // Implement the logic to filter duplicate custom chats here
        $selectMy.find('option').each(function() {
            // pārbaudam tikai custom grupas
            if (!$(this).data('iscustom')) {
                return;
            }

            // salīdzināšana notiek ar text (option tekstu), bet pārvietošana notiks pēc id (value)
            const myVal = $(this).text();
            const myId = $(this).val();

            let foundMy = false;
            let targetId = ''; // You need to define val or pass it as a parameter to this function.
            $selectSuggested.find('option').each(function() {
                const suggestedVal = $(this).text();
                if (suggestedVal === myVal) {
                    foundMy = true;
                    targetId = $(this).val();
                    return false;
                }
            });

            if (foundMy) {
                convertList.toSuggested[myId] = targetId;
                counter++;
            }

            // pārbaudam arī dublikātus starp custom un my sarakstu
            $selectMy.find('option').not(this).each(function() {
                const myValInner = $(this).text();
                if (myValInner === myVal) {
                    if (foundMy) {
                        convertList.toSuggested[$(this).val()] = targetId;
                    } else if (!convertList.toMy[myId]) {
                        convertList.toMy[$(this).val()] = myId;
                    }
                    counter++;
                }
            });
        });

        if (counter > 0) {
            const data = await ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: 'cht-duplicate-convert',
                    convertList: JSON.stringify(convertList)
                },
                dataType: 'json'
            });

            try {
                await ResponseDispatcher.handle(data, 'cht-duplicate-convert');
                if (data.ok) {
                    return false;
                }
            } catch (e) {
                console.error('Error handling custom list:', e);
            }

            return true;
        }

        return true;
    };

    appState.historyInstance.add('newconversation', {
        value: null,
        backCallback: function (change) {
            close(true);
        },
        checkCallback: function (value) {
            if ($newConversationContent.is(':visible')) {
                return true;
            }
            return null;
        },
        goBackOnRefresh: true
    });

    const chatHomeActions = {
        // chat home
        'cht-newconversation': (data) => {
            $('.chat2add').animate({ opacity: 0 }, 300).promise().then(() => {
                open();
            });
            return false;
        },
        'cht-newcreate': (data) => {
            newcreate();
            return false;
        },
        'cht-newcancel': (data) => {
            close();
            return false;
        },
    }
    ActionSets.registerSet('chatActions', chatHomeActions);

    $myConversations.off('click.chathome').on('click.chathome', '.mylistopener', function () {
        if ($myConversations.data('initdone')) {
            return;
        }
        if (!$myConversations.hasClass('use-template')) {
            return;
        }
        createMyFromTemplate().then(() => {
            if ($myConversations.hasClass('closed')) {
                $myConversations.toggleClass('closed');
                $myConversations.find('.list').slideToggle();
            }
        }).catch((e) => {

        });
    });

    $newConversationContent.off('click.chathome').on('click.chathome', '.chattype', function (event) {
        if ($(this).data('movetourl')) {
            event.preventDefault();
            $('.chattype[value="suggested"]').prop('checked', true);
            if ($(this).data('bk')) {
                lmAppStorage.saveBack('login', $(this).data('bk'));
                //document.dispatchEvent(new CustomEvent('app-storage:saveback', { detail: { key: 'login', url: $(this).data('bk') } }));
            }
            const url = $(this).data('movetourl');
            appState.historyInstance.afterPopstate = function () {
                setTimeout(function () {
                    window.location.assign(url);
                }, 20);
                return false;
            };
            close(false, true);
            return;
        }
        $('.chattype-content').not('[data-for="' + $(this).val() + '"]').hide();
        $('.chattype-content[data-for="' + $(this).val() + '"]').show();
    });


    const hasEncryptedContent = $('.select2chattype', context).find('option[data-secure="1"]').length > 0;
    if (hasEncryptedContent && !canSecureCrypt()) {
        await whenCrypter('decrypted');
        await sleep(10);
    }

    if (hasEncryptedContent && conf.manual) {
        await runAutoDecryptSmt(context).then(() => {
            $selectSuggested = $('.select2chattype[name="suggested"]', context);
            $selectMy = $('.select2chattype[name="my"]', context);
        }).catch(() => {
            throw new Error('Auto decrypt canceled');
        });
    }

    if ($('.select2chattype', context).length > 0) {
        $('.select2chattype', context).select2({
            dropdownAutoWidth: true,
            dropdownParent: dropdownParent,
            width: '100%',
            sorter: sorterCustom,
            templateResult: templateResultCounter,
            templateSelection: templateSelectionCounter
        });
    }

    const needOpenNewConversation = getUrlParam('newcustomconversation');
    if (needOpenNewConversation !== null) {
        const newUrl = setUrlParam('newcustomconversation');
        appState.historyInstance.currentUrl = newUrl;
        appState.historyInstance.startUrl = newUrl;
        setTimeout(function () {
            open(false, 'custom');
        }, 20);
    }

    // Ja izmantojam templeitu (tātad ielogojies), kamēr pin nav ievadīts, viss ir aizvērts un stāv templeitos;
    // Pēc pin ievadīšanas jāizveido ir saraksti (abi), un tikai tad var veikt filterDuplicateCustom
    // Bet tas arī jādara ir pie manuālas atvēršanas pēc pin ievadīšanas.
    if (useListTemplate) {
        whenCrypterReady().then(async () => {
            const promises = [];
            promises.push(createMyFromTemplate());
            promises.push(createNewFromTemplate());
            await Promise.all(promises).catch((err) => {
                throw err;
            });
        }).then(() => filterDuplicateCustom()).then((result) => {
            if (result) {
                // ja pin ir ievadīts atveram uzreiz ja ir aizvērts;
                if ($myConversations.hasClass('closed')) {
                    $myConversations.toggleClass('closed');
                    $myConversations.find('.list').show();
                }
                $myConversations.css('visibility', 'visible');
            }
        });

        if ($myConversations.hasClass('closed')) {
            $myConversations.css('visibility', 'visible');
        }
    } else {
        $myConversations.css('visibility', 'visible');
    }

    // atgriežam kontroles objektu
    return {
        open: open,
        close: close,
        myConversations: $myConversations
    };
}

function createOptionWithData(o) {
    // Izveidojam standarta opciju
    const opt = new Option(o.text, o.value, o.isSelected, o.isSelected);

    // Cikls cauri visiem saglabātajiem data- atribūtiem
    $.each(o.allDataAttrs, function(attrName, attrValue) {
        opt.setAttribute(attrName.toString(), attrValue);
    });

    return opt;
}

function newChatModalCreate(payload) {
    const $field = $(payload.html);
    const $dialog = $field.find('.modalView');
    const disableScroll = true;
    $('body').append($field);

    var modalManagerToken = null;
    if (modalManagerToken) {
        ModalManager.close(modalManagerToken);
    }
    modalManagerToken = ModalManager.open({
        name: payload.param || 'newChatModal',
        locksScroll: disableScroll
    });


    $field.css('opacity', 0).css('display', '').css('pointer-events', 'none');
    $field.stop(true, false).animate({
        opacity: 1
    }, 200, 'swing', function () {
        $(this).css({
            opacity: 1,
            'pointer-events': 'auto'
        });
    });
    $('.wbouter, .fx1a').animate({
        opacity: 0
    }, 200, 'swing');

    initChatHome({
        onOpen: () => {
            // You can now use the controls object here
        },
        onClose: () => {
            if (modalManagerToken) {
                ModalManager.close(modalManagerToken);
                modalManagerToken = null;
            }
            $field.remove();
            $('.wbouter, .fx1a').animate({
                opacity: 1
            }, 200, 'swing');
        },
        openTab: payload.openTab || null,
        selectOption: payload.selectOption || null,
        fillName: payload.fillName || '',
        context: $field.get(0),
        dropdownParent: $field.get(0),
        manual: true
    }).then((controls) => {
        // You can now use the controls object here
        controls.open();
    });
}

function bindChatEvents() {

    $('.tx-hints').on('click', 'button', function (event) {
        if ($(this).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }
        $(this).closest('.tx-hints').each(function () {
            const selfHint = this,
                show = $(selfHint).hasClass('show') ? false : true;
            let heightFrom, heightTarget;

            if (show) {
                heightFrom = $(this).find('.hintsc').height();
                heightTarget = $(this).find('.hintsc .ci').outerHeight();
            } else {
                heightFrom = $(this).find('.hintsc').height();
                heightTarget = 0;
            }

            $(this).find('.hintsc').stop(true, false).css({
                height: heightFrom
            }).animate({
                height: heightTarget
            }, 200, 'swing', function () {
                $(selfHint).toggleClass('show', show);
                $(this).css('height', '');
            });
        });
    });

    // čata meņu;
    var chatScroll = null;
    $('body').on('click', '.cht-admin-scroll', function (event) {
        chatScroll = new startChatScroll();
    });

    $('body').on('click', '.cht-scroll', function (event) {
        chatScroll = new startChatScroll($(this).data('speeds'));
    });

    $('body').on('click', '.cht-unscroll', function (event) {
        if (chatScroll) {
            chatScroll.stopFinal();
            chatScroll = null;
        }
    });
}

/* window['chat-form-rename-validate'] = function($field) {
    const val = $field.find('.j-newuuname').val();
    if (typeof validateChatterName === 'function') {
        const isValid = validateChatterName(val);
        if (!isValid) {
            $field.find('.j-newuuname').addClass('error-field').one('blur.autoerror change.autoerror keyup.autoerror', function () {
                $(this).removeClass('error-field');
            });
            return false;
        }
    }

    if ($field.find('input[name="chnrsel"]:checked').length > 0) {
        const selectedTitle = $field.find('input[name="chnrsel"]:checked').data('title');
        if (selectedTitle) {
            const lowerVal = val.toLowerCase();
            if (lowerVal === selectedTitle.toLowerCase()) {
                // vienādu atļaujam bet nodzēšam input kā tukšu;
                $field.find('.j-newuuname').val('');
                return true;
            }
            if (lowerVal.includes(selectedTitle.toLowerCase())) {
                $field.find('.j-newuuname').addClass('error-field').one('blur.autoerror change.autoerror keyup.autoerror', function () {
                    $(this).removeClass('error-field');
                });
                return false;
            }
        }
    }

    return true;
}; */



export function loadChat() {

    const chatIdCurrent = VarMgr.get('setChatIdCurrent');
    if (chatIdCurrent) {
        setUrlParam('id', chatIdCurrent);
    }

    var chatOptionsInit = false;

    // čats, miracle/connect
    if ($('textarea.chatinputbox').length) {
        bindChatEvents();

        chatState.instance = new initChatPage(false);
        ChatBoxEditable.init({
            selector: '.chatinputbox',
        })
        chatOptionsInit = true;
    }
    // library
    else if ($('.chatlist').length) {
        chatState.instance = new initChatPage(true);
        chatOptionsInit = true;
    }
    // library
    else if ($('.chathome').length) {
        chatState.instance = new initChatPage(true);
        chatOptionsInit = true;
    }

    if ($('.chathome').length) {
        initChatHome();
    } else if ($('.chatlist').length) {
        initChatHome().then(() => {
            const $selectLibrary = $('.select2chattype[name="library"]');
            $selectLibrary.on('change', function() {
                const val = $(this).val();
                const $opt = $(this).find('option[value="' + val + '"]');
                const url = $opt.data('url');
                if (!url) {
                    return false;
                }

                setTimeout(function () {
                    window.location.assign(url);
                }, 20);
            });

            // pārkārtojam options - vispirms suggested, tad custom alfabētiskā secībā
            let options = [];

            $selectLibrary.find('option').each(function() {
                const val = $(this).val();
                const isCustom = $(this).data('iscustom') ? true : false;

                // Ja opcijai ir tukša vērtība (piemēram, "Izvēlies..."), mēs to varam atstāt kā pirmo
                if (!val) return;

                let dataAttributes = {};
                $.each(this.attributes, function() {
                    if (this.name.startsWith('data-')) {
                        dataAttributes[this.name] = this.value;
                    }
                });

                options.push({
                    value: val,
                    text: $(this).text(),
                    isCustom: isCustom,
                    isSelected: $(this).is(':selected'),
                    allDataAttrs: dataAttributes
                });
            });

            // Sadalām divās grupās un sašķirojam ar localeCompare (atbalsta ā, č, ē utt.)
            const suggested = options.filter(o => !o.isCustom)
                                    .sort((a, b) => a.text.localeCompare(b.text, 'lv'));

            const custom = options.filter(o => o.isCustom)
                                .sort((a, b) => a.text.localeCompare(b.text, 'lv'));

            // Iztīrām veco select saturu (izņemot pirmo tukšo placeholder opciju, ja tāda ir)
            $selectLibrary.find('option[value!=""]').remove();
            // Ja bija optgroup-i, izdzēšam arī tos
            $selectLibrary.find('optgroup').remove();

            // Būvējam atpakaļ ieteiktos
            if (suggested.length > 0) {
                suggested.forEach(o => {
                    $selectLibrary.append(createOptionWithData(o));
                });
            }

            // Būvējam atpakaļ pielāgotos
            if (custom.length > 0) {
                $selectLibrary.append(createOptionWithData({
                    value: '',
                    text: '',//transGet('CHATTYPE_cust'),
                    isCustom: true,
                    isSelected: false,
                    allDataAttrs: {
                        disabled: true,
                        'data-customlabel': true
                    }
                }));
                custom.forEach(o => {
                    $selectLibrary.append(createOptionWithData(o));
                });
            }

            $selectLibrary.trigger('change.select2');
        });
    }

    // miracle/connect
    /* if ($('.connectchat').length) {
        chatOptionsInit = true;
    } */

    // čats, miracle/connect, archive?
    if (chatOptionsInit) {
        initChatOptions();
    }

    const loadChatPageScrollData = VarMgr.get('loadChatPageScroll');
    if (loadChatPageScrollData) {
        loadChatPageScroll(loadChatPageScrollData.url || null, loadChatPageScrollData.smart || false);
    }
}